const MODULE_NAME = 'fulcrum/container/Project/Thumbnail'

const FETCH_FILE_FOR_THUMBNAIL = MODULE_NAME + '/FETCH_FILE_FOR_THUMBNAIL'
const FETCH_FILE_FOR_THUMBNAIL_START = MODULE_NAME + '/FETCH_FILE_FOR_THUMBNAIL_START'
const FETCH_FILE_FOR_THUMBNAIL_SUCCESS = MODULE_NAME + '/FETCH_FILE_FOR_THUMBNAIL_SUCCESS'
const FETCH_FILE_FOR_THUMBNAIL_ERROR = MODULE_NAME + '/FETCH_FILE_FOR_THUMBNAIL_ERROR'
const ADD_THUMBNAIL_LINK = MODULE_NAME + '/ADD_THUMBNAIL_LINK'
const CLEAR_THUMBNAIL_LINKS = MODULE_NAME + '/CLEAR_THUMBNAIL_LINKS'

export {
    MODULE_NAME,
    FETCH_FILE_FOR_THUMBNAIL,
    FETCH_FILE_FOR_THUMBNAIL_START,
    FETCH_FILE_FOR_THUMBNAIL_SUCCESS,
    FETCH_FILE_FOR_THUMBNAIL_ERROR,
    ADD_THUMBNAIL_LINK,
    CLEAR_THUMBNAIL_LINKS
}